import { connect } from 'react-redux';
import { useSiteContext, useTranslation } from '@eti/providers';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { TRAVEL_INSURANCE_COVER_GENIUS } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { concatenateCoverGeniusTexts } from '../../common/utils/coverGeniusApiTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = TRAVEL_INSURANCE_COVER_GENIUS;
const sharedTexts = {
  ipidPolicyLinkText: 'coverGeniusIPIDPolicyLinkText',
  policyLinkText: 'coverGeniusPolicyLinkText',
  readMoreContent: 'travelInsuranceCoverGeniusAdditionalInformation',
  title: 'travelInsuranceCoverGeniusTitle'
};
const mainCardTranslations = {
  ...sharedTexts,
  abstractContent: 'travelInsuranceCoverGeniusAbstractText',
  upSell: 'travelInsuranceCoverGeniusUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'travelInsuranceCoverGeniusAbstractSmallCard',
    upSell: 'travelInsuranceCoverGeniusUpSellTextSmallCard'
  }
};
const TravelInsuranceCoverGenius = ({
  className,
  form,
  isSelected,
  order,
  sellSpecification,
  productCode,
  productPosition,
  productSpecificTexts,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  const {
    t,
    resolveTranslation
  } = useTranslation();
  const {
    market
  } = useSiteContext();
  const texts = translations[layoutType] || {};
  const isInUSMarket = market.code === 'US';
  const isInUKMarket = market.code === 'GB';
  const {
    isSmallCardLayout,
    productData,
    phonePrefixMarketTexts,
    rootElement,
    translation: {
      policyLinkText,
      ipidPolicyLinkText,
      readMoreContent
    }
  } = useProductData({
    productId: PRODUCT_ID,
    order,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    className,
    texts,
    layoutType
  });
  const {
    name,
    abstractText,
    smallCardAbstract
  } = phonePrefixMarketTexts || {};
  if (!productData) {
    return null;
  }
  const resolvedTitle = resolveTranslation(texts.title, name);
  const resolvedAbstractContent = resolveTranslation(texts.abstractContent, isSmallCardLayout ? smallCardAbstract : abstractText);
  const {
    disclaimer,
    ipid,
    termsUrl = ''
  } = productSpecificTexts || {};
  const terms = {
    url: termsUrl,
    text: policyLinkText
  };
  const ipidPolicy = {
    url: ipid === null || ipid === void 0 ? void 0 : ipid.url,
    text: ipidPolicyLinkText
  };
  const additionalInformationCoverGenius = concatenateCoverGeniusTexts({
    disclaimer: isInUSMarket && !isSmallCardLayout ? disclaimer : undefined,
    ipidPolicy: isInUKMarket ? ipidPolicy : undefined,
    terms: isInUKMarket ? terms : undefined,
    t,
    layoutType
  });
  const readMoreContentCoverGenius = concatenateCoverGeniusTexts({
    ipidPolicy: !isInUKMarket ? ipidPolicy : undefined,
    terms: !isInUKMarket ? terms : undefined,
    disclaimer: !isInUSMarket || isSmallCardLayout ? disclaimer : undefined
  });
  const coverGeniusLinks = isSmallCardLayout ? {
    description: `${resolvedAbstractContent} ${additionalInformationCoverGenius}`
  } : {
    additionalInformation: additionalInformationCoverGenius,
    description: resolvedAbstractContent
  };
  const updatedProductData = {
    ...productData,
    ...coverGeniusLinks,
    title: resolvedTitle,
    readMoreContent: readMoreContent + readMoreContentCoverGenius
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: updatedProductData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: updatedProductData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(TRAVEL_INSURANCE_COVER_GENIUS.name, form)(state)
});
export default connect(mapStateToProps)(TravelInsuranceCoverGenius);
//# sourceMappingURL=TravelInsuranceCoverGenius.js.map